// @flow

export const NOTAM_DETAILS_DIALOG_TOGGLE = 'notamDetailsDialog/TOGGLE';

export function toggleNotamDetailsDialog(visible: boolean) {
  return {
    type: NOTAM_DETAILS_DIALOG_TOGGLE,
    visible,
  };
}



// WEBPACK FOOTER //
// ./actions/notamDetailsDialog.js